/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { PartnerService } from '../services/partner.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EPartnerTabsEdit } from '../data/partner-tabs-edit.enum';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';
import { switchMap } from 'rxjs/operators';
import { EMPTY, Observable } from 'rxjs';
import { ResponseDefault } from 'src/app/shared/data/response-default.interface';
import { ICadastroEmployee } from '../../employee/employee/models/employee';
import { IListCentroCusto } from '../../employee/employee/models/list-centro-custo';
import { IFilialPartner } from '../../filiais/data/listpartner';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';

@Component({
  selector: 'app-edit-partner',
  templateUrl: './edit-partner.component.html',
  styleUrls: ['./edit-partner.component.scss']
})
export class EditPartnerComponent implements OnInit {

  formPartner = new UntypedFormGroup({
    active: new UntypedFormControl('', [Validators.required]),
    type: new UntypedFormControl('', [Validators.required]),
    name: new UntypedFormControl('', [Validators.required]),
    trading: new UntypedFormControl(''),
    document: new UntypedFormControl('', [Validators.required]),
    code: new UntypedFormControl(''),
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    phone: new UntypedFormControl('', [Validators.required]),
    id: new UntypedFormControl('')
  });
  ERoleAdminString = ERoleAdminString;
  opcoesFiliais: IFilialPartner[] = [];
  opcoesCentroCustos: IListCentroCusto[] = [];
  partnerLogo?: string | null;
  imageFile?: { link: string; file: any; name: string; base64: string };
  EPartnerTabsEdit = EPartnerTabsEdit;
  tabSelecionada: EPartnerTabsEdit = EPartnerTabsEdit.DadosParceiro;
  partnerId?: string;
  ordenarControl = new UntypedFormControl(1);
  employers: ICadastroEmployee[] = [];
  dadosPaginacaoColaborador = {
    ordenacao: EOrdenacao.AlfabeticaAZ,
    paginaSelecionada: 0,
    tamanhoPagina: 4,
    totalPaginas: 0,
    itensTotal: 0
  };

  constructor(
    private readonly partnerService: PartnerService,
    private readonly toastService: ToastService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef,
  ) { }

  public ngOnInit(): void {
    this.partnerId = this.activatedRoute.snapshot.paramMap.get('id')!;

    if (this.partnerId) {
      this.carregarDetalhesParceiro(this.partnerId);
    }
  }

  public carregarDetalhesParceiro(partnerId: string): void {
    this.formPartner.get('id')!.patchValue(partnerId);

    this.partnerService.detalhesParceiro(partnerId).subscribe((resposta) => {
      if (resposta.messages && resposta.messages.length > 0) {
        this.toastService.toast(resposta.messages);
      }

      if (resposta.isSucceed) {
        this.formPartner.get('type')!.patchValue(resposta.data.type);
        this.formPartner.get('name')!.patchValue(resposta.data.name);
        this.formPartner.get('trading')!.patchValue(resposta.data.trading);
        this.formPartner.get('document')!.patchValue(resposta.data.document);
        this.formPartner.get('code')!.patchValue(resposta.data.code);
        this.formPartner.get('email')!.patchValue(resposta.data.email);
        this.formPartner.get('phone')!.patchValue(resposta.data.phone);
        this.formPartner.get('active')!.patchValue(resposta.data.active);
        this.partnerLogo = resposta.data.logo;
      }
    });
  }

  public editarParceiro(): void {
    if (this.formPartner.valid) {
      this.partnerService
        .editarParceiro(this.formPartner.getRawValue())
        .pipe(
          switchMap((resposta) => {
            if (resposta.messages && resposta.messages.length > 0) {
              this.toastService.toast(resposta.messages);
            }

            if (resposta.isSucceed && this.imageFile) {
              return this.salvarImagem();
            }
            this.router.navigateByUrl('/dash/parceiros');
            return EMPTY;
          })
        )
        .subscribe((resposta) => {
          if (resposta.messages && resposta.messages.length > 0) {
            this.toastService.toast(resposta.messages);
          }

          this.router.navigateByUrl('/dash/parceiros');
        });
    }
  }

  public salvarImagem(): Observable<ResponseDefault<boolean>> {
    const imagemFormData = new FormData();

    imagemFormData.append('id', String(this.partnerId));
    imagemFormData.append('image', this.imageFile!.file);

    return this.partnerService.adicionarImagemParceiro(imagemFormData);
  }

  public mudarTabSelecionada(tabSelecionada: EPartnerTabsEdit): void {
    this.tabSelecionada = tabSelecionada;
  }

  public onImageInput(evento: Event): void {
    const { files } = evento.target as HTMLInputElement;

    if (files && files.length > 0) {
      const reader = new FileReader();

      reader.readAsDataURL(files[0]);

      reader.onload = (_event: any) => {
        this.imageFile = {
          link: _event.target.result,
          file: files[0],
          name: files[0].name,
          base64: reader.result!.toString().split(',')[1]
        };

        this.partnerLogo = this.imageFile.base64;

        this.cdr.markForCheck();
      };
    }
  }
}
